module.exports = __webpack_public_path__ + "static/img/jiangxu_hui.367aedf6.svg";